import React from 'react';

const button = props => <button className={`btn ${props.className || ''}`}
    aria-label={props.text}
    title={props.text}
    disabled={props.disabled || false}
    onClick={props.onClick}>
    {props.children} {props.showOnlyIcon || false ? null : props.text}
</button>;

export default button;